import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ListWebhooksResponse } from '@xver/apis/v1/sammeln/webhooks/model';

export const WEBHOOKS_QUERY_KEY = 'apis.v1.sammeln.webhooks.list';

export function useWebhooksQuery(projectIdOrName: string) {
    return useQuery<ListWebhooksResponse>({
        queryKey: [WEBHOOKS_QUERY_KEY, projectIdOrName],
        queryFn: () => Endpoints.v1.Sammeln.Webhooks.listWebhooks(projectIdOrName),
        enabled: !!projectIdOrName,
        staleTime: 0,
        refetchOnMount: 'always',
        refetchOnWindowFocus: 'always',
    });
}
